import { render, staticRenderFns } from "./cheXingWeihu.vue?vue&type=template&id=6c5446db&scoped=true"
import script from "./cheXingWeihu.vue?vue&type=script&lang=js"
export * from "./cheXingWeihu.vue?vue&type=script&lang=js"
import style0 from "./cheXingWeihu.vue?vue&type=style&index=0&id=6c5446db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5446db",
  null
  
)

export default component.exports